import { strategyMap } from '../strategies';
import { DefaultEventRuleSetStrategy } from '../strategies/DefaultEventRuleSetStrategy';
import { RuleSetStrategy } from '../strategies/RuleSetStrategy';
import { RuleContext } from '../types/RuleContext';

export class RuleSetStrategyFactory {
  static getStrategy(context: Partial<RuleContext>): RuleSetStrategy {
    const { event } = context;
    const category = event!.categories.find(cat => strategyMap[cat.name]);
    if (category) {
      return new strategyMap[category.name]();
    }
    return new DefaultEventRuleSetStrategy();
  }
}
